<div
  class="tw-reset tw-relative tw-mx-4 tw-grid tw-h-dvh tw-place-items-center md:tw-mx-0"
>
  <div
    class="tw-absolute tw-top-14 tw-w-full tw-max-w-full tw-rounded-2xl tw-bg-white tw-p-6 tw-pb-4 tw-shadow-xl md:md:tw-w-[488px]"
    role="dialog"
    aria-labelledby="title"
  >
    <div class="tw-flex tw-flex-col">
      <h4
        class="tw-mb-4 tw-font-extrabold tw-text-neutral-900"
        id="title"
        tabindex="-1"
        #titleElement
      >
        {{ ModalTitle() }}
      </h4>
      <div class="tw-text-neutral-80 tw-max-w-md tw-pb-2 tw-text-xs">
        <div class="tw-text-base tw-font-extrabold tw-text-neutral-900">
          {{ translate('Description', 'Core_descriptionLabel') }}
        </div>
        <div
          #textContent
          [class]="
            twMerge(
              'tw-text-content tw-overflow-hidden tw-transition-all tw-duration-300',
              expanded() ? 'tw-line-clamp-none' : 'tw-line-clamp-1'
            )
          "
        >
          {{ ModalDescription() }}
        </div>

        <!-- Show More button (only visible if content is clamped) -->
        @if (isClamped()) {
          <div class="tw-w-full">
            <button
              (click)="expanded.set(!expanded())"
              class="tw-btn-small tw-btn-tertiary"
            >
              {{
                expanded()
                  ? translate('Show Less', 'Core_showLessButtonText')
                  : translate('Show More', 'Core_showMoreButtonText')
              }}
              <da-icon
                type="solid"
                class="tw-mx-1 tw-size-4"
                [icon]="expanded() ? 'chevron-up' : 'chevron-down'"
                [solidSize]="20"
              ></da-icon>
            </button>
          </div>
        }
      </div>
      @if (!clearSelectionFlag() && currentRatingObject()) {
        <div class="tw-w-full">
          <!-- TO-DO: selected rating  -->
          <div
            class="tw-w-full tw-text-sm tw-font-semibold tw-text-neutral-800"
          >
            {{
              isTarget
                ? translate(
                    'Current Target Rating',
                    'Core_CurrentTargetRatingLabel'
                  )
                : translate(
                    'Current Self Rating',
                    'Core_CurrentSelfRatingLabel'
                  )
            }}
          </div>
          <div
            class="tw-inline-flex tw-w-full tw-border-b tw-border-solid tw-border-neutral-300"
          >
            <dgx-tag-rating-donut
              class="tw-m-4 tw-ml-0"
              size="sm"
              [level]="currentRatingObject()?.value.toString()"
              [showDefaultPlus]="false"
              [isOwner]="true"
            ></dgx-tag-rating-donut>
            <div class="tw-m-auto tw-flex-grow">
              <p class="tw-text-sm tw-text-neutral-800">
                {{ currentRatingObject()?.name }}
              </p>
            </div>
            <div class="tw-m-auto">
              <button
                class="tw-btn-secondary-filled tw-text-xs"
                (click)="clearSelection($event)"
              >
                {{
                  isTarget
                    ? translate('Clear Target', 'Core_ClearCurrentTargetRating')
                    : translate(
                        'Clear Rating',
                        'Core_ClearcurrentRatingObject()'
                      )
                }}
              </button>
            </div>
          </div>
        </div>
      }
      <div class="tw-py-4">
        <div class="tw-inline-flex tw-w-full">
          <p
            class="tw-flex-grow tw-pb-0 tw-text-sm tw-font-semibold tw-text-neutral-800"
          >
            {{ skillLabel() }}
          </p>
          <button
            class="tw-btn-secondary-filled tw-text-xs"
            (click)="clearCurrentSelection($event)"
          >
            {{ translate('Clear Selection', 'Core_ClearCurrentSelection') }}
          </button>
        </div>
        <div
          class="tw-text-content tw-text-neutral-80 tw-w-full tw-pt-2 tw-text-xs"
        >
          {{
            this.translate(
              'Description for the rating type',
              this.isTarget
                ? 'Core_SkillTargetDescription'
                : 'dgTagRating_UnratedDescription'
            )
          }}
        </div>
      </div>

      <form
        [formGroup]="ratingsForm"
        class="tw-relative tw-mb-4 tw-flex-grow tw-items-center tw-justify-between tw-overflow-y-auto tw-px-1"
      >
        <ul
          class="tw-mt-1 tw-flex tw-w-full tw-flex-col tw-gap-4 tw-rounded-xl tw-bg-white"
        >
          @if (ratingLevels().length) {
            @for (level of ratingLevels(); track level) {
              <li
                class="tw-inline-flex tw-items-center tw-border-b tw-border-solid tw-border-neutral-200 tw-pb-4"
              >
                <dgx-tag-rating-donut
                  class="tw-m-4 tw-ml-0"
                  size="sm"
                  [level]="level.value.toString()"
                  [showDefaultPlus]="false"
                  [isOwner]="true"
                ></dgx-tag-rating-donut>
                <div class="tw-mr-2 tw-flex-grow">
                  <p class="tw-pb-0 tw-text-neutral-800">{{ level.name }}</p>
                  <p class="tw-pb-0 tw-text-xs tw-text-neutral-600">
                    {{ level.description }}
                  </p>
                </div>
                <input
                  formControlName="level"
                  type="radio"
                  [id]="level.name + '-' + level.value"
                  name="level"
                  [value]="level.value"
                  [checked]="false"
                />
              </li>
            }
          } @else {
            @for (i of [1, 2, 3, 4, 5]; track i) {
              <li
                class="tw-items-center tw-border-b tw-border-solid tw-border-neutral-200 tw-pb-4"
              >
                <div class="tw-pt-2">
                  <dgx-skeleton type="mediumTitle"></dgx-skeleton>
                  <dgx-skeleton type="list" [rows]="2"></dgx-skeleton>
                </div>
              </li>
            }
          }
        </ul>
      </form>

      <div
        class="tw-flex tw-flex-col tw-justify-end tw-gap-2 md:tw-flex-row md:tw-gap-4"
      >
        <button
          class="tw-btn-medium tw-btn-secondary-filled"
          (click)="dimissRating()"
        >
          {{ translate('Cancel', 'Core_Cancel') }}
        </button>
        <button
          class="tw-btn-primary tw-btn-medium"
          (click)="submitRating()"
          [disabled]="ratingsForm.invalid"
          [class.is_disabled]="ratingsForm.invalid"
          [attr.aria-disabled]="ratingsForm.invalid"
        >
          {{
            isTarget
              ? translate('Select Target', 'Core_SaveTargetRating')
              : translate('Save Rating', 'Core_SaveSelfRating')
          }}
        </button>
      </div>
    </div>
  </div>
</div>
